import {
    useContent,
    useExperienceContent,
} from '../../../../hooks/use-server-content';
import { FMMastheadContent } from '../../../../views/fm-home-page/hooks/use-fm-masthead-content';

export interface RecallsUnitedContent {
    hide: boolean;
    breadcrumbLabel: string;
    recallsTitle: string;
    recallsDescription: string;
    authRecallsDescription: string;

    signInTitleWithUsername: string;
    signInTitleWithoutUsername: string;
    vinInputTitle: string;
    vinLabel: string;
    signInDescription: string;
    signInCtaLabel: string;
    whereDoIFindMyVinTitle: string;
    whereDoIFindMyVinLink: string;
    vinSearchCtaLabel: string;
    searchByVinLabel: string;
    searchByVinDescription: string;
    openDrawerAriaLabel: string;
    closeDrawerAriaLabel: string;
    vinInputDrawerTitle: string;
    addVehicleCtaLabel: string;
    addVehicleCtaLink: string;
    changeVehicleButtonLabel: string;

    switchVehicle: string;
    safetyRecallsLabel: string;
    recallIncompleteLabel: string;
    recallRemedyNotAvailableTitle: string;
    recallRemedyNotAvailableDescription: string;
    remedyNotAvailableCtaLabel: string;
    dateLabel: string;
    campaignLabel: string;
    descriptionLabel: string;
    safetyRiskLabel: string;
    remedyLabel: string;
    nextStepsLabel: string;
    nextStepsRecalls: string;
    nextStepsCsp: string;
    recallsDisclaimerSymbol: string;
    recallsDisclaimer: string;
    cspLabel: string;
    cspDisclaimerSymbol: string;
    cspDisclaimer: string;
    closeDisclaimerAriaLabel: string;
    openRecallDetailsAriaLabel: string;
    closeRecallModalAriaLabel: string;
    recallScheduleServiceTitle: string;
    recallScheduleServiceDescription: string;
    recallScheduleServiceCtaLink: string;
    recallScheduleServiceCtaLabel: string;
    recallScheduleServiceCtaTargetBlank: boolean;
    cspScheduleServiceTitle: string;
    cspScheduleServiceDescription: string;

    doNotDriveTitle: string;
    doNotDriveDescription: string;
    doNotDriveText: string;

    noRecallsMessage: string;
    noCspMessage: string;
    noRecallNoCspMessage: string;
    userHasNoVehicleMessage: string;
    apiFailureErrorMessage: string;

    ymmCtaToModalLabel: string;
    authYmmCtaToModalLabel: string;
    modalTitle: string;
    modalDescription: string;
    yearDropdownLabel: string;
    modelDropdownLabel: string;
    submitLabel: string;
    ymmDisclaimer: string;
    recallsLastUpdatedText: string;
    recallsInformationUpToThisDateText: string;
}
export const useRecallsUnitedContent = (): RecallsUnitedContent | null => {
    const [content, getValueByName] = useContent('recalls', 'recalls-united');
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.breadcrumbLabel) {
            contentFragment = null;
        }
    }

    return contentFragment as RecallsUnitedContent;
};

export const useRecallsRecentLinksContent = (): FMMastheadContent => {
    const [recentRecallsLinksFragment] = useExperienceContent<
        FMMastheadContent
    >('recalls', 'recent-recalls-united-links', 'popular_links_sectio');
    return recentRecallsLinksFragment as FMMastheadContent;
};
